import React, { Component } from 'react';

import { loginInfo } from '../../../global';

import { Card, CardBody, CardGroup, Col, Container, Input, InputGroup, InputGroupAddon, InputGroupText, Row } from 'reactstrap';

import { AsyncSelectField, DateTimeField, TextField, LanguageSelect, Label, LoadingButton as Button } from "../../../components/FormControl";

import withDraggablePopup from '../../../components/withDraggablePopup';
import ResetPassword from "../../../containers/Master/ResetPassword";

const param = require('jquery-param');

const ResetPasswordPopupCtrl = withDraggablePopup(ResetPassword, {
  title: <Label>Forgot password?</Label>,
  slideIn: "Down"
})

class Login extends Component {

  openResetPassword = () => {
    this.nameInput.openWindow({});
  }

  render() {


    const { standardProps, isAfterSave, onSubmit, getFormData, ...restProps } = this.props;


    return (
      <div className="app flex-row align-items-center login-container">
        <ResetPasswordPopupCtrl
          isKiosk={true}
          ref={(input) => {
            this.nameInput = input;
          }}
          {...this.props}
        >
        </ResetPasswordPopupCtrl>
        <Container>
          <Row className="justify-content-center">
            <Col md="12">
              {/* <i className="ml-auto mr-auto foodify-logo-circle "></i> */}
              <Row className="form-group">
                <Col xs="12" md="12" className="p-0">

                  <TextField
                    name="UserID"
                    id="UserID"
                    placeholder="User Name"
                    {...standardProps}
                    // Prefix={() => (
                    //   <div className="input-group-prepend">
                    //     <span className="input-group-text">
                    //       <i className="icon user-icon"></i></span>
                    //   </div>
                    // )}
                    onKeyUp={(event) => {
                      if (event.key === 'Enter') {

                        this.SubmitButton.click();
                        // onSubmit();
                      }
                    }}
                  />

                </Col>
              </Row>

              <Row className="form-group">
                <Col xs="12" md="12" className="p-0">

                  <TextField
                    name="Password"
                    id="Password"
                    type="password"
                    placeholder="Password"
                    {...standardProps}
                    // Prefix={() => (
                    //   <div className="input-group-prepend">
                    //     <span className="input-group-text">
                    //       <i className="icon lock-icon"></i></span>
                    //   </div>
                    // )}
                    onKeyUp={(event) => {
                      if (event.key === 'Enter') {
                        // onSubmit();
                        this.SubmitButton.click();
                      }
                    }}
                  />

                </Col>
              </Row>

              <Row className="form-group">
                <Col xs="12" md="12">
                  {/* <Button color="link" className="px-0">Forgot password?</Button> */}
                  <LanguageSelect notUpdateServer={true}></LanguageSelect>
                </Col>
              </Row>

              <Row className="form-group">
                <Col xs="12" md="12">
                  <Button color="primary" className="px-4"
                    // onClick={() => {
                    //   return Promise.resolve({ 'result': '1' })
                    // }}
                    bindref={(input) => {
                      this.SubmitButton = input;
                    }}
                    onClick={onSubmit}

                  ><Label>Login</Label></Button>
                </Col>
              </Row>

              <div className="text-center">
                <span style={{ fontWeight: 'bold', textDecoration: 'underline', cursor: 'pointer' }} onClick={this.openResetPassword}><Label>Forgot password?</Label></span>
                <div className="mt-1" style={{ lineHeight: 1 }}><small>
                  <Label>Primal Chemical - Trading Management System</Label><br />
                  <Label>Copyright © 2019 FlexSystem Limited. All Right Reserved.</Label><br />
                  <Label>All other trademark are properties of their repective owners.</Label>
                </small></div>
              </div>

            </Col>
          </Row>
        </Container>
      </div >
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/views/Pages/Login/Login.v2.js